
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[encodedName]",
      function () {
        return require("private-next-pages/products/[encodedName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[encodedName]"])
      });
    }
  